import {Utils} from "./utils";
import {Utility} from "./libs/utility";
import {CalendarWidget} from "./main";
import {ResizeHelper} from "./helpers/resize-helper";
import {Recommenderbar} from "./recommenderbar";

export class Menu {

	private static classInActiveHeader = "_inActive";
	private static classOtherPagesExpanded = "_isExpanded";
	private static classActiveSubMenu = "activeSubMenu";
	private static classActive = "active";
	private static doc: HTMLElement;
	private static scroll: number;
	private static isTop: boolean;
	private static isMenuOpen = false;
	private static mainMenuWrapper: HTMLElement;
	private static isMobileMenuOpen = false;
	private static resizeHelper: ResizeHelper;
	private static bgMenuToggle: HTMLElement;
	private static navWrapperHeight: number;
	private static mainLogoElement: HTMLElement;
	private static recommenderbarIsTop = true;
	private static recommenderbarIsTopBefore = true;

	public static init() {
		Menu.doc = document.documentElement;
		var mainMenuWrapper = document.getElementById("nav_mainMenuWrapper");
		if(mainMenuWrapper === null){
			return;
		}else{
			Menu.mainMenuWrapper = mainMenuWrapper;
		}
		Menu.resizeHelper = new ResizeHelper(() => Menu.resizeFinished());
		document.addEventListener('DOMContentLoaded', Menu.onDocumentLoaded, false);
		window.addEventListener("scroll", Menu.onScroll);
	}

	private static onDocumentLoaded() {
		Menu.setActiveMenu();
		Menu.setNavWarpperHeight();
		Menu.setMainLogoDomElement();
		Menu.checkScrollForMenu();
		Menu.initMouseEvents();
	}

	private static setNavWarpperHeight() {
		Menu.navWrapperHeight = Menu.mainMenuWrapper.offsetHeight;
	}

	private static setMainLogoDomElement() {
		Menu.mainLogoElement = document.getElementById('header_mainLogo');
	}

	private static setActiveMenu(){
		var subMenuLists = Menu.mainMenuWrapper.getElementsByClassName('_mainMenuItem');
		var windowLocation = window.location.toString();
		var mainMenu = document.getElementsByTagName('main')[0];
		var subsubMenuParent = null;
		if(mainMenu != null)
		 subsubMenuParent= mainMenu.getAttribute('parentsubmenu');

		if(windowLocation[windowLocation.length -1] != '/'){
			windowLocation += '/';
		}

		for(var i =0; i< subMenuLists.length; i++){
			var subMenuLinks = subMenuLists.item(i).getElementsByTagName('a');

			for(var x =0; x<subMenuLinks.length; x++){
				var href = subMenuLinks.item(x).href;
				if(href[href.length -1] != '/'){
					href += '/';
				}
				if(href == windowLocation){
					subMenuLinks.item(x).classList.add(Menu.classActive);
					var mainMenuItemLink = subMenuLists.item(i).getElementsByTagName('a')[0];
					mainMenuItemLink.classList.add('currentActive');
				}
				if(subsubMenuParent != null){
					if(href.indexOf(subsubMenuParent) !== -1){
						subMenuLinks.item(x).classList.add(Menu.classActive);
						var mainMenuItemLink = subMenuLists.item(i).getElementsByTagName('a')[0];
						mainMenuItemLink.classList.add('currentActive');
					}
				}
			}
		}
	}

	private static onScroll() {
		Menu.checkScrollForMenu();
		Menu.checkScrollForRecommenderbar();
	}

	private static checkScrollForRecommenderbar() {
		let scroll = (window.pageYOffset || Menu.doc.scrollTop)  - (Menu.doc.clientTop || 0);
		let isTopHasChanged = false;

		Menu.recommenderbarIsTop = scroll <= 100;

		if(Menu.recommenderbarIsTop !== Menu.recommenderbarIsTopBefore){
			isTopHasChanged = true;
			Menu.recommenderbarIsTopBefore = Menu.recommenderbarIsTop;
		}else{
			isTopHasChanged = false;
		}

		if(isTopHasChanged) {
			Recommenderbar.toggleRecommenderbar(Menu.recommenderbarIsTop);
		}
	}

	private static checkScrollForMenu(){

		Menu.scroll = (window.pageYOffset || Menu.doc.scrollTop)  - (Menu.doc.clientTop || 0);
   		Menu.isTop = true;
    	if(Menu.scroll <= 10 && !Menu.isMenuOpen){
        	Menu.isTop = true;
    	}else{
        	Menu.isTop = false;
		}
		Menu.toggleMenu(Menu.isTop);
	}

	private static toggleMenu(isTop: boolean){
		if(isTop){
			if(!Menu.mainMenuWrapper.classList.contains(Menu.classInActiveHeader)){
				Menu.mainMenuWrapper.classList.remove("fadeToBlue");
				Menu.mainMenuWrapper.classList.add("fadeToTransparent");
				Menu.mainMenuWrapper.classList.add(Menu.classInActiveHeader);
				Menu.mainLogoElement.style.paddingTop = '0px';
			}

		}else{
			if(Menu.mainMenuWrapper.classList.contains(Menu.classInActiveHeader)){
				Menu.mainMenuWrapper.classList.add("fadeToBlue");
				Menu.mainMenuWrapper.classList.remove("fadeToTransparent");
				Menu.mainMenuWrapper.classList.remove(Menu.classInActiveHeader);
				Menu.mainLogoElement.style.paddingTop = Menu.navWrapperHeight.toString() + 'px';
			}
		}
	}

	private static initMouseEvents(){
		var toggleMenu = document.getElementById("_menuToggle");
		if(toggleMenu != null){
			toggleMenu.addEventListener('click', Menu.clickMenuToggle);
			toggleMenu.addEventListener('click', Menu.clearSearch);
		}
		var toggleMobileCalendar = document.getElementById("_mobileCalendarToggle");
		if(toggleMobileCalendar != null){
			toggleMobileCalendar.addEventListener('click', Menu.clickMenuToggle);
		}
		var body = document.getElementsByTagName("body");
		if(body != null && body.length > 0 && body.item(0) != null){
			body.item(0).addEventListener('click', Menu.clickBody);
		}
		var closeSearchButton = document.getElementById("closeSearchIcon");
		if(closeSearchButton != null){
			closeSearchButton.addEventListener('click', Menu.clearSearch);
		}
		var searchInput = <HTMLElement>Menu.mainMenuWrapper.getElementsByClassName("_searchInput").item(0);
		if(searchInput != null){
			searchInput.addEventListener('input', Menu.onchangeSearchInput);
		}
		var moblieMenuBackButtons = document.getElementsByClassName("_moblieMenuBack");
		for(var i = 0; i < moblieMenuBackButtons.length; i++){
			moblieMenuBackButtons.item(i).addEventListener('click',Menu.closeAllMenus);
		}
		var footerMenu = document.getElementsByClassName("_footerListHeadline");
		for(var i = 0; i < footerMenu.length; i++){

			var footerMenuIcon = footerMenu.item(i).firstElementChild;

			if(footerMenuIcon != null){
				footerMenuIcon.addEventListener('click', Menu.toggleFooterMenu);
			}
		}
		var subMenuInnerItems = Menu.mainMenuWrapper.getElementsByClassName('_subMenuInnerItem');
		for(var i = 0; i<subMenuInnerItems.length; i++){
			subMenuInnerItems.item(i).addEventListener('click', Menu.removeActiveFromSubmenus);
		}
		var mainMenuItems = Menu.mainMenuWrapper.getElementsByClassName('_mainMenuItem');
		for(var i = 0; i<mainMenuItems.length; i++){
			mainMenuItems.item(i).getElementsByTagName('a')[0].addEventListener('focusin',Menu.clickOpenSubmenu);
		}
		var caledaricon = document.getElementById('calendarIcon');
		if(caledaricon != null){
			caledaricon.addEventListener('focusin', Menu.closeAllMenus);
		}
		var skipToMenu = document.getElementById('skipToMenu');
		if(skipToMenu != null){
			skipToMenu.getElementsByTagName('a')[0].addEventListener('focusin', Menu.closeAllMenus);
		}

		Menu.bgMenuToggle = document.getElementById('_bgMenuToggle');
		if(Menu.bgMenuToggle != null) {
			Menu.bgMenuToggle.addEventListener('click', Menu.toggleBgMenu);
		}
	}

	private static toggleBgMenu() {
		var bgMenuContent = document.getElementById('_bgMenuContent');
		Menu.bgMenuToggle.classList.toggle(Menu.classOtherPagesExpanded);
		bgMenuContent.classList.toggle(Menu.classOtherPagesExpanded);

	}

	private static toggleFooterMenu(event: MouseEvent){
		var toToggleMenu = <HTMLElement>event.target;

		if(toToggleMenu == null) {
			return;
		}

		toToggleMenu.classList.toggle("icon-plus");
		toToggleMenu.classList.toggle("icon-minus");

		if(toToggleMenu.parentElement != null){
			if(toToggleMenu.parentElement.nextElementSibling != null){
				toToggleMenu.parentElement.nextElementSibling.classList.toggle("_footerList");
			}
		}
	}

	private static clickCalendarButton() {
		const calArea = document.getElementById("nav_calWrapper");
		var button =  document.getElementById("calendarIcon");


		if(calArea == null || button == null) {
			return;
		}

		const isVisible = calArea.classList.contains("_show");
		Menu.closeNavSearch();
		Utility.toggleClass(calArea, "_show", !isVisible);

		if(!isVisible) {
			CalendarWidget.showInMenu('nav_calWidget');
			Menu.toggleMenu(false);
			Menu.isMenuOpen = true;
		}else{
			Menu.toggleMenu(Menu.isTop);
			Menu.isMenuOpen = false;
		}

		var arrowUp = calArea.getElementsByClassName("arrowUp");
		var arrowUpBorder = calArea.getElementsByClassName("arrowUpBorder");
		(<HTMLElement>arrowUpBorder[0]).style.left = button.offsetLeft + "px";


	}

	private static clickSearchButton(){
		var searchArea = <HTMLElement>document.getElementById("nav_search");
		var button = document.getElementById("searchIcon");

		var body = document.getElementsByTagName("body");

		if(button == null) {
			return;
		}

		let input = document.getElementById("s") as HTMLElement;
		Menu.closeNavCalendar();
		if(searchArea.classList.contains("_show")){
			searchArea.classList.remove("_show");
			searchArea.classList.add("_hide");
			Menu.isMenuOpen =false;
			Menu.toggleMenu(Menu.isTop);
		}else{
			searchArea.classList.remove("_hide");
			searchArea.classList.add("_show");
			Menu.isMenuOpen = true;
			Menu.toggleMenu(false);
		}
		var arrowUp = searchArea.getElementsByClassName("arrowUp");
		(<HTMLElement>arrowUp[0]).style.left = button.offsetLeft + "px";
		var closeButton = <HTMLElement>searchArea.getElementsByClassName("icon-close").item(0);
		closeButton.addEventListener("click",Menu.clickSearchButton);


		input.focus();
	}

	private static onchangeSearchInput(){
		var closeSearchButton = document.getElementById("closeSearchIcon");
		var mobileSearchButton = document.getElementById("mobileSearchIcon");

		if(closeSearchButton == null || mobileSearchButton == null) {
			return;
		}

		closeSearchButton.style.display = "block";
        mobileSearchButton.style.display = "none";
	}

	private static clearSearch(){
		var searchInput = <HTMLInputElement>Menu.mainMenuWrapper.getElementsByClassName("_searchInput").item(0);
		var searchResult = <HTMLElement>Menu.mainMenuWrapper.getElementsByClassName("ajax_search_response").item(0);
		var closeSearchButton = document.getElementById("closeSearchIcon");
		var mobileSearchButton = document.getElementById("mobileSearchIcon");

		if(closeSearchButton == null || mobileSearchButton == null) {
			return;
		}

		closeSearchButton.style.display = "none";
		if(Menu.isMoblieMenu()){
			mobileSearchButton.style.display = "block";
		}

		if(searchInput != null) {
			searchInput.value = "";
		}

		if(searchResult == null) {
			return;
		}

		if(searchResult.parentNode != null){
			searchResult.parentNode.removeChild(searchResult);
		}
	}

	private static clickMenuToggle(event: MouseEvent){
		var mainMenu = <HTMLElement>Menu.mainMenuWrapper.getElementsByClassName("_mainMenu").item(0);
		var navMenu =  <HTMLElement>Menu.mainMenuWrapper.getElementsByClassName("_navMenu").item(0);

		var calendar = document.getElementById("nav_calWrapper");
		var menuBurgerIcon = document.getElementById("_menuToggle");
		var menuCalendarIcon = document.getElementById("_mobileCalendarToggle");
		var toggle = null;

		if(event.target != null){
			if((<Element>(event.target)).classList.contains("_leftMenu")){
				toggle = document.getElementById("_menuToggle");
			}else if((<Element>(event.target)).classList.contains("_rightMenu")){
				toggle = document.getElementById("_mobileCalendarToggle");
			}
		}

		//var toggle = document.getElementById("_menuToggle");//<HTMLElement>event.target;

		if(toggle == null){
			return;
		}
		var body = document.getElementsByTagName("body");

		if(body != null && body.length > 0 && body.item(0) != null){
			body.item(0).classList.toggle("_openMenu");
		}

		if(menuBurgerIcon == null ||menuCalendarIcon == null){
			return;
		}
		var subMenu = Menu.mainMenuWrapper.getElementsByClassName("_subMenu ");
			for(var i =0; i< subMenu.length; i++){
				var subMenuItem = <HTMLElement>subMenu.item(i);
				subMenuItem.style.display = 'none';
			}


		if(Menu.isMobileMenuOpen){
			Menu.isMobileMenuOpen = false;
			mainMenu.classList.remove("slideInLeft");
			Menu.addSlideOutLeft(mainMenu);
			navMenu.classList.remove("slideInLeft");
			Menu.addSlideOutLeft(navMenu);
			toggle.classList.toggle("icon-close");
			menuBurgerIcon.classList.toggle("icon-burger-menu");
			menuCalendarIcon.classList.toggle("icon-calendar");

			if(calendar != null){
				calendar.classList.remove("_show");
				calendar.classList.remove("slideInLeft");
				Menu.addSlideOutLeft(calendar);
			}
        }else{
			Menu.isMobileMenuOpen = true;
			mainMenu.classList.remove("slideOutLeft");
			Menu.addSlideInLeft(mainMenu);
			toggle.classList.toggle("icon-close");

			if(toggle.classList.contains("icon-burger-menu")){
				navMenu.classList.remove("slideOutLeft");
				Menu.addSlideInLeft(navMenu);
				toggle.classList.toggle("icon-burger-menu");
				menuCalendarIcon.classList.toggle("icon-calendar");

			} else{
				Menu.clickCalendarButton();
				Menu.addSlideOutLeft(navMenu);
				navMenu.classList.remove("slideInLeft");
				menuBurgerIcon.classList.toggle("icon-burger-menu");

				if(calendar != null){
					calendar.classList.remove("slideOutLeft");
					Menu.addSlideInLeft(calendar);
					toggle.classList.toggle("icon-calendar");
				}
			}
		}
	}

	private static openSubMenu(event: MouseEvent){
		var element = <HTMLElement>event.target
        Menu.closeAllMenus();
		Menu.toggleMenu(false);
		if(element !== null){
			element.classList.add(Menu.classActive);
			var parent = <HTMLElement>element.parentElement;
			let subMenu:HTMLElement;
			if(!Menu.isMoblieMenu()){
				subMenu = <HTMLElement>parent.querySelector("._subMenu");
			}else if(element.classList.contains("_mainMenuItem"))
			{
				subMenu = <HTMLElement>element.querySelector("._subMenu");
			}else{
				subMenu = <HTMLElement>parent.querySelector("._subMenu");
			}
			if(subMenu !== null){
				if(Menu.isMoblieMenu()){
					subMenu.classList.remove("slideOutRight");
					subMenu.classList.add('slideInRight');
					subMenu.style.display = "block";
					var innersubMenu = <HTMLElement>subMenu.getElementsByClassName('_subMenuInner')[0];
					innersubMenu.style.marginLeft = '0';
				}else{
					subMenu.classList.add(Menu.classActiveSubMenu);
					Menu.calcSubMenuPositions(subMenu,parent);
				}

			}
		}
		Menu.isMenuOpen = true;
	}


	private static calcSubMenuPositions(subMenu: HTMLElement,mainMenuEntry : HTMLElement){
		if(!Menu.isMoblieMenu()){
			var firstColumn = <HTMLElement>subMenu.querySelector("ul._first");
			var secondColumn = <HTMLElement>subMenu.querySelector("ul._second");
			if(secondColumn != null){
				secondColumn.style.height = firstColumn.offsetHeight + "px";
			}
			var marginLeft = mainMenuEntry.offsetLeft;
			var subMenuInner = <HTMLElement>subMenu.getElementsByClassName("_subMenuInner")[0];
			subMenuInner.style.marginLeft = marginLeft + "px";
		}
	}

	private static closeNavCalendar(){
		Menu.isMenuOpen = false;
		var navCalendar = document.getElementById('nav_calWrapper');
		if(navCalendar != null && navCalendar.classList.contains('_show')){
			navCalendar.classList.remove('_show');
		}
		Menu.checkScrollForMenu();
	}

	private static closeNavSearch(){
		Menu.isMenuOpen = false;
		var navSearch = document.getElementById('nav_search');
		if(navSearch != null && navSearch.classList.contains('_show')){
			navSearch.classList.remove('_show');
		}
		Menu.checkScrollForMenu();
	}

	private static clickOpenSubmenu(event: MouseEvent){
		var element = <HTMLElement>event.target
		if (element.classList.contains('active')) {
            return;
        }
		Menu.closeNavCalendar();
		Menu.closeNavSearch();
		Menu.openSubMenu(event);
		Menu.checkScrollForMenu();
	}

	private static clickBody(event: MouseEvent){
		var target = <HTMLElement> event.target;

		if(Utils.isClassInAncestors(target,"_subMenuFooter")){
			Menu.closeAllMenus();
		}else if(target.parentElement != null && target.parentElement.classList.contains("_mainMenuItem")) {
			if(target != null){
				Menu.clickOpenSubmenu(event);
				//Menu.closeNavCalendar();
				//Menu.closeNavSearch();
				//Menu.openSubMenu(event);
				//Menu.checkScrollForMenu();
			}
		}else if(Utils.isClassInAncestors(target,"_searchContainer")){
		}else if(Utils.isClassInAncestors(target,"_subMenu")){
			if(Menu.isMoblieMenu()){
				Menu.clickMenuToggle(event);
			}
		}else if(Utils.isClassInAncestors(target, "_menuCalendarIcon")){
			if(target != null && !Menu.isMoblieMenu()){
				Menu.closeAllMenus();
				Menu.clickCalendarButton();
			}
		}else if(Utils.isClassInAncestors(target, "_menuSearchIcon")){
			if(target != null){
				Menu.closeAllMenus();
				Menu.clickSearchButton();
			}
		}else{
			Menu.closeAllMenus();
			if(!Menu.isMoblieMenu()){
				Menu.closeNavCalendar();
				Menu.closeNavSearch();
			}
		}
	}

	private static closeAllMenus(){
		Menu.removeActiveFromMenus();
		var subMenus = <NodeListOf<HTMLElement>>Menu.mainMenuWrapper.querySelectorAll("._subMenu");
		for (var i = 0; i < subMenus.length; i++) {
			if(Menu.isMoblieMenu()){
				subMenus[i].classList.remove("slideInRight");
				subMenus[i].classList.add("slideOutRight");
			}else{
				subMenus[i].classList.remove(Menu.classActiveSubMenu);
				subMenus[i].classList.remove("slideOutRight");
			}
		}
		Menu.isMenuOpen = false;
		Menu.checkScrollForMenu();
	}

	private static removeActiveFromMenus(){
        var mainMenus = Menu.mainMenuWrapper.getElementsByClassName("_mainMenuItem");
        for (var i = 0; i < mainMenus.length; i++) {
			mainMenus[i].getElementsByTagName('a')[0].classList.remove(Menu.classActive);
        }
	}
	private static removeActiveFromSubmenus(event: MouseEvent){
		var subMenuScheduleList = Menu.mainMenuWrapper.getElementsByClassName('_scheduleSubmenuList')[0].getElementsByTagName('li');
		for(var i =0; i<subMenuScheduleList.length; i++){
			if(subMenuScheduleList.item(i).getElementsByTagName('a')[0].classList.contains('active')){
				subMenuScheduleList.item(i).getElementsByTagName('a')[0].classList.remove('active');
			}
		}
		var activeScheduleSubmenu = <HTMLElement>event.target;
		activeScheduleSubmenu.classList.add('active');
		Menu.closeAllMenus();
	}


	public static isMoblieMenu(){
		var mobileMenu = <HTMLElement>document.getElementById("nav_mobileMenu");
		var style = window.getComputedStyle(mobileMenu,undefined);
		if(style.display === "block"){
			return true;
		}else{
			return false;
		}
	}

	private static resizeFinished(){
		Menu.closeAllMenus();
		Menu.closeNavSearch();
		Menu.closeNavCalendar();
		Menu.removeMobileClasses();
		Menu.resetIconsAndSubmenu();
	}

	private static resetIconsAndSubmenu(){
		var subMenu = Menu.mainMenuWrapper.getElementsByClassName("_subMenu");

		if(Menu.isMoblieMenu()){
			var mobileMenu = document.getElementById('_menuToggle');
			var mobileMenuCalendar = document.getElementById('_mobileCalendarToggle');
			for(var i =0; i< subMenu.length; i++){
				var subMenuItem = <HTMLElement>subMenu.item(i);
				subMenuItem.style.display = 'none';
			}
			if(mobileMenu == null ||mobileMenuCalendar== null){
				return;
			}
			mobileMenu.classList.remove('icon-close');
			mobileMenuCalendar.classList.remove('icon-close');
			mobileMenu.classList.add('icon-burger-menu');
			mobileMenuCalendar.classList.add('icon-calendar');
		} else{
			for(var i =0; i< subMenu.length; i++){
				var subMenuItem = <HTMLElement>subMenu.item(i);
				subMenuItem.style.display = 'block';
			}
		}
	}

	private static removeMobileClasses(){
		let elementsSlideOut = document.getElementsByClassName("slideOutLeft");
		for(let i = 0; i < elementsSlideOut.length; i++){
			elementsSlideOut[i].classList.remove("slideOutLeft");
		}
		let elementsslideInLeft = document.getElementsByClassName("slideInLeft");
		for(let i = 0; i < elementsslideInLeft.length; i++){
			elementsslideInLeft[i].classList.remove("slideInLeft");
		}
		let elementsSlideOutRight = document.getElementsByClassName("slideOutRight");
		for(let i = 0; i < elementsSlideOutRight.length; i++){
			elementsSlideOutRight[i].classList.remove("slideOutRight");
		}
		let elementsslideInRight = document.getElementsByClassName("slideInRight");
		for(let i = 0; i < elementsslideInRight.length; i++){
			elementsslideInRight[i].classList.remove("slideInRight");
		}
	}

	private static addSlideOutLeft(el:HTMLElement){
		if(Menu.isMoblieMenu){
			el.classList.add("slideOutLeft");
		}
	}
	private static addSlideInLeft(el:HTMLElement){
		if(Menu.isMoblieMenu){
			el.classList.add("slideInLeft");
		}
	}

}
